import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { RolePositionContent } from "PFApp/components/card_tx/content/role_position_content";
import { RolePositionFooter } from "PFApp/components/card_tx/footer/role_position_footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type AuditRoleVariantProps = Pick<
  CardTxContentProps,
  "task" | "type" | "isFeed" | "isDraft" | "isHotVisible" | "interestedIn" | "handleShare"
>;

export const AuditRoleVariant = ({
  task,
  type,
  isFeed,
  isDraft,
  isHotVisible,
  interestedIn,
  handleShare
}: AuditRoleVariantProps) => (
  <>
    <Header task={task} type={type} isFeed={isFeed} onShare={handleShare} />
    <Status isPrivate={task.private} isDraft={isDraft} />
    <RolePositionContent task={task} isFeed={isFeed} />
    <RolePositionFooter isHotVisible={isHotVisible} interestedIn={interestedIn} />
  </>
);
